module.exports = __webpack_public_path__ + "static/media/animated-octopus-loading.f22f0d90.gif";